import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2023 - 2025",
      title: "Associate in System & Network Management",
      place: "Thomas More Geel",
      desc: "System & Network Administrator",
    },
    {
      yearRange: "2016 - 2023",
      title: "High School Degree",
      place: "Sint-Jozef Geel",
      desc: "Industrial Maintenance Technician",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2020 - 2023",
      title: "Industrial Maintenance Technician",
      place: "ArcelorMittal Geel",
      desc: "Maintenance on industrial machines",
    },
    {
      yearRange: "2021",
      title: "Truck Mechanic",
      place: "Transmekaniek Remy BV",
      desc: "Maintenance on trucks",
    },
  ];

  const skills = [
    {
      name: "Networking",
      percent: 70,
    },
    {
      name: "System Management",
      percent: 85,
    },
    {
      name: "Microsoft",
      percent: 70,
    },
    {
      name: "Azure",
      percent: 70,
    },
    {
      name: "Python",
      percent: 55,
    },
    {
      name: "Virtual Machines",
      percent: 80,
    },
  ];

  return (
    <section id="resume" className="section custom-bg-dark">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp text-white">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5 text-white">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp text-white">My Skills</h2>
        <div className="row gx-5 text-white">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-light shadow-none rounded-0"
            target="blank"
            href={resumeFile}
          >
            Download CV
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
